<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>營運資料中心</b-breadcrumb-item>
            <b-breadcrumb-item active>會員名單查詢與匯出</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <h4>會員名單查詢與匯出</h4>

        <div class="row mx-0 justify-content-between mb-2 mt-3">
          <div>
            <b-button v-b-toggle.collapse-filter variant="outline-info" class="mr-2">
              <span class="mdi mdi-filter"></span>篩選條件
            </b-button>
          </div>
          <div>
            <b-dropdown text="匯出" variant="primary" class="mr-2">
              <b-dropdown-item @click="listExport">清單匯出</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <b-collapse id="collapse-filter" class="mt-2">
          <div class="border p-2 small">
            <b-form>
              <div class="d-flex flex-column flex-xl-row flex-wrap">
                <!-- 通路名稱 -->
                <b-form-group
                  label="通路名稱"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-select
                    class="mr-3"
                    v-model="query.merchant_id"
                    :options="merchants"
                    :disabled="merchants.length == 2 || showLoading"
                  ></b-form-select>
                </b-form-group>

                <!-- 下單時間 -->
                <b-form-group
                  label="下單時間"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <DateSearchPicker
                    class="mr-md-2 mr-0"
                    v-model="orderDateBetween"
                    startedPlaceholder="開始時間"
                    endedPlaceholder="結束時間"
                    size="sm"
                    :disabled="showLoading"
                    @input="handleDateChange"
                  />
                </b-form-group>

                <!-- 金額篩選 -->
                <b-form-group
                  label="金額篩選"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="2"
                  label-cols-lg="1"
                  content-cols-lg="10"
                  style="width: 100%"
                >
                  <div class="d-flex align-items-center flex-wrap">
                    <b-form-radio-group
                      v-model="amountFilterType"
                      :options="amountFilterOptions"
                      :disabled="showLoading"
                      size="sm"
                      class="mr-3"
                      @change="handleAmountTypeChange"
                    ></b-form-radio-group>
                    <b-form-input
                      v-model.number="amountMin"
                      type="number"
                      placeholder="最低金額"
                      class="mr-2"
                      style="width: 120px;"
                      size="sm"
                      :disabled="showLoading"
                    ></b-form-input>
                    <span class="mx-1">～</span>
                    <b-form-input
                      v-model.number="amountMax"
                      type="number"
                      placeholder="最高金額"
                      class="ml-2"
                      style="width: 120px;"
                      size="sm"
                      :disabled="showLoading"
                    ></b-form-input>
                    <span class="ml-2">元</span>
                  </div>
                </b-form-group>

                <!-- 商品名稱 -->
                <b-form-group
                  label="商品標題/規格名稱"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.item_name"
                    placeholder="搜尋 商品標題/規格名稱"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

                <!-- 商品代號 -->
                <b-form-group
                  label="商品規格代碼/序號"
                  label-align="left"
                  label-class="pt-0 pb-0 d-flex align-items-center"
                  class="align-items-center"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  content-cols-lg="7"
                  style="width: 50%"
                >
                  <b-form-input
                    class="mr-3"
                    v-model="query.item_code"
                    placeholder="搜尋 訂單明細編號/規格代碼/規格序號"
                    size="sm"
                    :disabled="showLoading"
                  ></b-form-input>
                </b-form-group>

              </div>

              <div class="flex-column">
                <b-button
                  variant="primary"
                  class="mb-2 mb-xl-0 mr-2"
                  @click="resetSearch"
                  ><i class="mdi mdi-restart"></i> 重置搜尋條件</b-button
                >
                <b-button
                  variant="primary"
                  class="mb-2 mb-xl-0"
                  @click="handleSearch"
                  ><i class="fa fa-search"></i> 搜尋
                </b-button>
              </div>
            </b-form>
          </div>
        </b-collapse>

        <b-table
          responsive
          striped
          hover
          :items="items"
          :fields="dynamicFields"
          @sort-changed="handleSort"
          class="mt-3"
        >
          <!-- 會員姓名 - 使用 customer.name key，b-table 會自動處理巢狀資料 -->

          <!-- 訂單編號 -->
          <template #cell(order_number)="data">
            <router-link
              v-if="data.item.id"
              :to="{
                name: 'OrderDetail',
                params: {
                  order_id: data.item.id,
                },
              }"
            >
              {{ data.item.order_number }}
            </router-link>
            <span v-else>{{ data.item.order_number || '-' }}</span>
          </template>


          <!-- 其他說明 -->
          <template #cell(memo)="data">
            <div class="d-flex flex-column align-items-center">
              <span
                v-if="data.item.memo"
                v-b-modal.modal-memo-view
                class="mdi mdi-tag-text-outline mr-1"
                style="cursor: pointer; font-size: 1rem;"
                :id="`popover-memo-${data.item.id}-${data.index}`"
                @click="modalTitle = '消費備註', modalContent = data.item.memo"
              ></span>
              <b-popover
                v-if="data.item.memo"
                :target="`popover-memo-${data.item.id}-${data.index}`"
                triggers="hover focus"
              >
                <div class="text-left">點擊，觀看『消費備註』</div>
              </b-popover>

              <span
                v-if="data.item.processed_memo"
                v-b-modal.modal-memo-view
                class="mdi mdi-coin"
                style="cursor: pointer; font-size: 1rem;"
                :id="`popover-points-${data.item.id}-${data.index}`"
                @click="modalTitle = '入點說明', modalContent = data.item.processed_memo"
              ></span>
              <b-popover
                v-if="data.item.processed_memo"
                :target="`popover-points-${data.item.id}-${data.index}`"
                triggers="hover focus"
              >
                <div class="text-left">點擊，觀看『入點說明』</div>
              </b-popover>
            </div>
          </template>
        </b-table>

        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />

        <!-- Memo View Modal -->
        <b-modal id="modal-memo-view" :title="modalTitle">
          <div class="p-3" style="white-space: pre-wrap; max-height: 400px; overflow-y: auto;">{{ modalContent }}</div>
          <template #modal-footer="{ cancel }">
            <b-button
              variant="outline-danger"
              size="sm"
              class="float-right"
              @click="cancel()"
            >
              關閉
            </b-button>
          </template>
        </b-modal>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { format } from "date-fns";
import customerApi from "@/apis/customer";
import merchantApi from "@/apis/merchant";
import * as consts from "@/consts";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import DateSearchPicker from "@/components/Page/Dashboard/DateSearchPicker.vue";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import { paginationMixin } from "@/mixins/pagination";

export default {
  name: "CustomerSearchExport",
  mixins: [paginationMixin],
  components: { CustomPagination, DateSearchPicker },
  data() {
    return {
      consts,
      showLoading: false,
      merchants: [{ value: null, text: "全部" }],
      totalRows: 0,
      // 會員基本欄位
      baseFields: [
        { key: "customer.name", label: "會員姓名", sortable: false, thStyle: { minWidth: "100px" }, tdClass: 'text-truncate-hover' },
      ],
      searchedMerchant: {},
      items: [],
      initialized: false,
      orderDateBetween: {
        start_at: null,
        end_at: null,
      },
      query: {
        page: 1,
        per_page: 10,
        sort_by: "order_at",
        order_by: "desc",
        merchant_id: null,
        order_at_from: null,
        order_at_to: null,
        total_min: null,
        total_max: null,
        customer_total_min: null,
        customer_total_max: null,
        item_name: "",
        item_code: "",
      },
      modalTitle: null,
      modalContent: null,
      amountFilterType: 'single',
      amountFilterOptions: [
        { value: 'single', text: '單筆訂單金額' },
        { value: 'total', text: '訂單加總金額' },
      ],
      amountMin: null,
      amountMax: null,
    };
  },
  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    // 動態計算要顯示的欄位
    dynamicFields() {
      return this.baseFields
        .concat(this.normalizeProfileFields())
        .concat(this.orderFields);
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchOrders();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  async mounted() {
    // 載入 customer 模組設定
    await this.$store.dispatch("dashboardModule/fetchModule", {
      org_id: this.organization.id,
      code: "customer",
    });
    this.fetchMerchants();
    this.initialized = true;
  },
  methods: {
    async fetchOrders() {
      this.showLoading = true;

      // 搜尋時更新 searchedMerchant，用於動態欄位計算
      this.searchedMerchant = this.merchants.find(m => m.value === this.query.merchant_id) || {};

      try {
        const params = { ...this.query };

        if (typeof params.merchant_id !== 'undefined' && params.merchant_id === 'null') {
          params.merchant_id = null;
        }

        // 移除空值的參數
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === "") {
            delete params[key];
          }
        });

        const { data } = await customerApi.getCustomerOrders(params);

        this.items = data.data;
        this.totalRows = data.meta.total;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "取得資料錯誤", "error");
      }
      this.showLoading = false;
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: "null", text: "全部" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
            type: merchant.type
          };
        }),
      ];

      if (!this.query.merchant_id) {
        const merchants = data.data;
        let defaultMerchant =
          merchants.find(
            (merchant) => merchant.type === this.defaultMerchantType
          ) ?? merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);

        if (defaultMerchant) {
          this.query.merchant_id = defaultMerchant.id;
        }
      }

      // 若已有選中的 merchant_id，同步設定 searchedMerchant 物件
      if (this.query.merchant_id && !this.searchedMerchant.value) {
        this.searchedMerchant = this.merchants.find(m => m.value === this.query.merchant_id) || {};
      }

      await this.fetchOrders();
    },
    handleDateChange(event) {
      if (event.start_at) {
        this.query.order_at_from = format(new Date(event.start_at), "yyyy-MM-dd");
      } else {
        this.query.order_at_from = null;
      }
      if (event.end_at) {
        this.query.order_at_to = format(new Date(event.end_at), "yyyy-MM-dd");
      } else {
        this.query.order_at_to = null;
      }
    },
    resetSearch() {
      this.orderDateBetween = {
        start_at: null,
        end_at: null,
      };

      // 重置金額築選
      this.amountFilterType = 'single';
      this.amountMin = null;
      this.amountMax = null;

      // 當只有一間通路時，固定選取該通路
      const defaultMerchantId = this.merchants.length === 2
        ? this.merchants[1].value
        : null;

      this.query = {
        page: 1,
        per_page: 10,
        sort_by: "order_at",
        order_by: "desc",
        merchant_id: defaultMerchantId,
        order_at_from: null,
        order_at_to: null,
        total_min: null,
        total_max: null,
        customer_total_min: null,
        customer_total_max: null,
        item_name: "",
        item_code: "",
      };
      this.fetchOrders();
    },
    handleAmountTypeChange() {
      // 切換類型時清空輸入值
      this.amountMin = null;
      this.amountMax = null;
    },
    handleSearch() {
      // 根據金額篩選類型同步到對應的 query 欄位
      if (this.amountFilterType === 'single') {
        this.query.total_min = this.amountMin;
        this.query.total_max = this.amountMax;
        this.query.customer_total_min = null;
        this.query.customer_total_max = null;
      } else {
        this.query.customer_total_min = this.amountMin;
        this.query.customer_total_max = this.amountMax;
        this.query.total_min = null;
        this.query.total_max = null;
      }
      this.query.page = 1;
      this.fetchOrders();
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageReset();
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
    },
    async listExport() {
      try {
        this.showLoading = true;

        const params = {
          merchant_id: this.query.merchant_id !== 'null' ? this.query.merchant_id : null,
          sort_by: this.query.sort_by,
          order_by: this.query.order_by,
        };

        // 有值才傳送
        Object.keys(this.query).forEach(key => {
          if (this.query[key] !== null && this.query[key] !== "" && !['page', 'per_page', 'sort_by', 'order_by', 'merchant_id'].includes(key)) {
            params[key] = this.query[key];
          }
        });

        await customerApi.exportCustomerOrders(params);

        this.$swal({
          title: "成功",
          text: "可至「我的主控台」查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "匯出失敗", "error");
      } finally {
        this.showLoading = false;
      }
    },
    // 根據模組設定解析會員欄位
    normalizeProfileFields() {
      // order.customer_list 是在 customer 模組的 module_config 內
      const customerList = this.getModuleConfig("customer", "order.customer_list");
      console.log('[DEBUG] customerList:', customerList);
      if (!customerList || customerList.length === 0) return [];

      let profileMappings = [];

      // 當 searchedMerchant 沒有 type（全部或尚未搜尋）時，使用第一筆設定
      if (!this.searchedMerchant?.type) {
        profileMappings = customerList[0]?.member_fields ?? [];
      } else {
        // 根據 merchant_type 匹配對應設定
        profileMappings = customerList.find(
          (list) => list.merchant_type?.toUpperCase() === this.searchedMerchant?.type?.toUpperCase()
        )?.member_fields ?? [];
      }

      return profileMappings.map((mapping) => {
        if (mapping.matched_key.startsWith("extra.")) {
          // extra.name -> customer.profiles.name
          const key = mapping.matched_key.split("extra.")[1];
          return {
            key: `customer.profiles.${key}`,
            label: mapping.title,
          };
        } else {
          // mobile_phone -> customer.mobile_phone
          return {
            key: `customer.${mapping.matched_key}`,
            label: mapping.title,
          };
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}
</style>
